import React, { Fragment, useState } from "react";
import BusinessList from "src/Components/Custom/BusinessList/BusinessList";
import BusinessPostlDetail from "src/Components/Custom/BusinessPostDetail/BusinessPostDetail";
import BusinessPostModal from "src/Components/Custom/BusinessPostModal/BusinessPostModal";
import EndPoints from "src/Constants/EndPoints";
import { useTranslation } from "react-i18next";

function Business({ modalVisibility, setModalVisibility }: any) {
  const [search, setSearch] = useState<string>('');
  const [postData, setPostData] = useState<any>([]);
  const [detailView, setDetailView] = useState<boolean>(false);
  const { t, i18n } = useTranslation();

  return (
    <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-9">
            <div className="col_selector">
              <div className="messages pt-4 post_feed">
                {detailView ? (
                  <BusinessPostlDetail
                    postData={postData}
                    setPostData={setPostData}
                    setDetailView={setDetailView}
                    setModalVisibility={setModalVisibility}
                  />
                ) : (
                    <BusinessList
                      endPoint={EndPoints.businessPosts}
                      placeholderMessage={"Sales Post not found"}
                      setPostData={setPostData}
                      setModalVisibility={setModalVisibility}
                      setDetailView={setDetailView}
                      search={search}
                      setSearch={setSearch}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalVisibility ? (
        <BusinessPostModal
          postData={postData}
          setPostData={setPostData}
          showModal={modalVisibility}
          setModalVisibility={setModalVisibility}
        />
      ) : (
          <Fragment />
        )}
    </div>
  )
}

export default Business;